import React from "react";
import { Button, Row, Col } from "reactstrap";

interface ProposalFormFooterProps {
  currentStep: number;
  totalSteps: number;
  onPrevious: () => void;
  onNext: () => void;
  onSaveDraft: () => void;
  isSubmitting?: boolean;
  skipMandatory: boolean;
  onSkipMandatoryChange: (value: boolean) => void;
}

const ProposalFormFooter: React.FC<ProposalFormFooterProps> = ({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  onSaveDraft,
  isSubmitting = false,
  skipMandatory,
  onSkipMandatoryChange,
}) => {
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === totalSteps;

  return (
    <div className="form-footer">
      <Row className="align-items-center">
        <Col md={4}>
          <div className="footer-left">
            <Button
              className="save-draft-btn"
              color="light"
              outline
              onClick={onSaveDraft}
              disabled={isSubmitting}
            >
              Save Draft
            </Button>
          </div>
        </Col>
        <Col md={4} className="d-flex justify-content-center">
          <div className="skip-mandatory-checkbox form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="skipMandatory"
              checked={skipMandatory}
              onChange={(e) => onSkipMandatoryChange(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="skipMandatory">
              Skip Mandatory Fields
            </label>
          </div>
        </Col>
        <Col md={4}>
          <div className="footer-right">
            <Button
              className="previous-btn"
              color="light"
              outline
              onClick={onPrevious}
              disabled={isFirstStep || isSubmitting}
            >
              Previous
            </Button>
            <Button
              className="save-next-btn"
              onClick={onNext}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Processing...
                </>
              ) : isLastStep ? (
                "Submit"
              ) : (
                "Save & Next"
              )}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ProposalFormFooter;

